export const FETCH_BRANDS = 'FETCH_BRANDS';
export const SET_BRAND = 'SET_BRAND';
export const GET_BRAND_INFO = 'GET_BRAND_INFO';
export const SET_BRAND_INFO = 'SET_BRAND_INFO';
export const ADD_BRAND = 'ADD_BRAND';
export const ADD_SUCCESS_BRAND = 'ADD_SUCCESS_BRAND';
export const FETCH_SEARCH_BRANDS = 'FETCH_SEARCH_BRANDS';
export const SET_SEARCH_BRAND = 'SET_SEARCH_BRAND';
export const UPDATE_BRAND = 'UPDATE_BRAND';
export const DELETE_BRAND = 'DELETE_BRAND';
export const DELETE_BRAND_REQUEST = 'DELETE_BRAND_REQUEST';
export const DELETE_BRAND_SUCCESS = 'DELETE_BRAND_SUCCESS';
export const ADD_SUCCESS_FAVORITE = 'ADD_SUCCESS_FAVORITE';
export const FETCH_BRAND_COUNTERS = 'FETCH_BRAND_COUNTERS';
export const FETCH_COUNTER_BRANDS = 'FETCH_COUNTER_BRANDS';
export const SET_COUNTER_BRANDS = 'SET_COUNTER_BRANDS';
export const SET_BRAND_COUNTERS = 'SET_BRAND_COUNTERS';
export const UPDATE_BRANDS = 'UPDATE_BRANDS';
export const UPDATE_BRANDS_FIELDS = 'UPDATE_BRANDS_FIELDS';
export const GET_BRAND_NAME = 'GET_BRAND_NAME';
export const SET_BRAND_NAME = 'SET_BRAND_NAME';
export const ADD_UPDATE_BRAND = 'ADD_UPDATE_BRAND';
export const SET_ADD_UPDATE_BRAND = 'SET_ADD_UPDATE_BRAND';
export const SET_ADD_UPDATE_BRAND_SNACKBAR = 'SET_ADD_UPDATE_BRAND_SNACKBAR';
export const BACKUP_MOVE_FILE = 'BACKUP_MOVE_FILE';
export const SET_MOVE_FILE_RESPONSE = 'SET_MOVE_FILE_RESPONSE';
export const FETCH_YEARS = 'FETCH_YEARS';
export const FETCH_MAKES = 'FETCH_MAKES';
export const FETCH_MODELS = 'FETCH_MODELS';
export const FETCH_TRIMS = 'FETCH_TRIMS';
export const ADD_CUSTOM_META_DATA_VEHICLE = 'ADD_CUSTOM_META_DATA_VEHICLE';
export const ADD_SUCCESS_CUSTOM_META_DATA_VEHICLE = 'ADD_SUCCESS_CUSTOM_META_DATA_VEHICLE';
export const FETCH_STYLES = 'FETCH_STYLES';
export const FETCH_VEHICLES = 'FETCH_VEHICLES';
export const SET_VEHICLE = 'SET_VEHICLE';
export const FETCH_DATA_STYLES = 'FETCH_DATA_STYKLES';
export const FETCH_DATA = 'FETCH_DATA';
export const SET_DATA = 'SET_DATA';

